// src/pages/ForgotPasswordPage.tsx
import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Typography, Result } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';

const { Title, Text } = Typography;

export const ForgotPasswordPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const response: any = await authAPI.forgotPassword(String(values.email || '').trim().toLowerCase());
      setEmailSent(true);
      message.success(response.data?.message || 'Письмо с инструкциями отправлено на ваш email');
    } catch (error: any) {
      console.error('Forgot password error:', error);
      message.error(error.response?.data?.detail || 'Ошибка при отправке письма. Попробуйте снова.');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        backgroundColor: '#F0F9F4',
        padding: '20px'
      }}>
        <Card 
          style={{ 
            width: '100%', 
            maxWidth: 500,
            borderRadius: '12px',
            boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
          }}
        >
          <Result
            status="success"
            title="Письмо отправлено!"
            subTitle="Проверьте вашу почту. Мы отправили вам инструкции по восстановлению пароля. Ссылка действительна в течение 1 часа."
            extra={[
              <Button 
                type="primary" 
                key="login"
                onClick={() => navigate('/login')}
                size="large"
              >
                Вернуться к входу
              </Button>
            ]}
          />
        </Card>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      backgroundColor: '#F0F9F4',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          width: '100%', 
          maxWidth: 500,
          borderRadius: '12px',
          boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
        }}
        title={
          <div style={{ textAlign: 'center' }}>
            <Title level={2} style={{ color: '#263238', marginBottom: 0 }}>Восстановление пароля</Title>
            <Text type="secondary">Введите ваш email для получения инструкций</Text>
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Пожалуйста, введите email' },
              { type: 'email', message: 'Введите корректный email' }
            ]}
          >
            <Input 
              prefix={<MailOutlined />} 
              placeholder="your.email@example.com"
              size="large"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              style={{ 
                width: '100%', 
                backgroundColor: '#7CB342',
                borderColor: '#7CB342',
                height: '48px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Отправить инструкции
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Button 
            type="link" 
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
          >
            Вернуться к входу
          </Button>
        </div>
      </Card>
    </div>
  );
};
